export const repeatRuleDefaultValues = {
  repeatAnnually: null,
};
